import { useCallback } from 'react';

import { getPlaceholdersForTask, removePlaceholdersForTask } from '~/utils/importPlaceholderTracking';
import { useRemoveAssetsFromAllViews } from '~/utils/mutateUtils/GalleryAssets';

export const useCleanupImportPlaceholders = () => {
  const { removeAssetsFromAllViews } = useRemoveAssetsFromAllViews();

  const cleanupPlaceholders = useCallback(
    (localTaskId: string) => {
      const tracked = getPlaceholdersForTask(localTaskId);
      if (!tracked) return;

      const result = removeAssetsFromAllViews({
        clipIds: tracked.clipIds,
        parentBoardId: tracked.parentBoardId,
      });

      removePlaceholdersForTask(localTaskId);

      return result;
    },
    [removeAssetsFromAllViews],
  );

  return { cleanupPlaceholders };
};
